







































import {
  defineComponent,
  ref,
  computed,
  useContext
} from '@nuxtjs/composition-api';
import { useVSFContext } from '@vue-storefront/core';
import { useKECart, useTranslations } from '@vue-storefront/novulo';
import {
  addCurrency,
  calculateInsurancePrice,
  getBrowserDetails,
  getCurrencyCode,
  priceFormat
} from '~/helpers/utils';

export default defineComponent({
  name: 'PDPCarePlan',
  props: {
    product: {
      type: Object,
      required: true,
      default: () => ({})
    },
    isInsuranceSelected: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:isInsuranceSelected'],
  setup(props, { emit }) {
    const context = useContext();
    const vsfContext = useVSFContext();
    const { translate } = useTranslations();
    const { loading: isCartLoading, addToCart } = useKECart();

    const isDrawerOpen = ref(false);
    const isLoading = ref(false);

    const insuranceTitle = computed(
      () => props.product.insurance_product?.insurance_title
    );
    const insuranceDescription = computed(
      () => props.product.insurance_product?.description
    );
    const careplanInfoHTML = computed(
      () => props.product.insurance_product?.insurance_html || ''
    );
    const productName = computed(() => props.product.name);
    const image = computed(
      () => props.product.product_image_gallery?.[0]?.media_url
    );

    const insurancePrice = computed(() => {
      const wt = vsfContext.$novulo.config.state.getWt();
      return calculateInsurancePrice({
        itemPrice: props.product.price,
        isNetherlands: [11, 51].includes(wt),
        isGermany: [21, 28, 30, 35, 57, 60, 61].includes(wt),
        isLu: [24, 25].includes(wt),
        isBe: [40, 43, 7, 20, 53].includes(wt)
      });
    });

    const insuranceSelected = computed<boolean>({
      get: () => props.isInsuranceSelected,
      set: (newVal) => {
        emit('update:isInsuranceSelected', newVal);
      }
    });

    const careplanDescriptionKey = computed(() => {
      const wt = vsfContext.$novulo.config.state.getWt();
      // photogalerie.com + all .be sites
      const isBe = [40, 42, 43, 7, 20, 53].includes(wt);
      const suffix = isBe ? '_be' : '_nl';

      return `pdp_careplan_description${
        insuranceSelected.value ? '_selected' : ''
      }${suffix}`;
    });

    const toggleInsuranceSelection = () => {
      insuranceSelected.value = !insuranceSelected.value;
    };

    const applyCareplan = async () => {
      if (isLoading.value) return;
      isLoading.value = true;

      await addToCart({
        spliId: props.product.spli_id,
        combidealIds: null,
        quantity: 1,
        shouldAddInsurance: true,
        category: props.product.category,
        brand: props.product.brand,
        name: props.product.name,
        price: props.product.price,
        list: 'Product detail',
        sku: props.product.sku,
        currency: getCurrencyCode({ vsfContext }),
        browserDetails: getBrowserDetails({ vsfContext, i18n: context.i18n })
      });

      isLoading.value = false;
    };

    const closeDrawer = () => {
      isDrawerOpen.value = false;
    };

    const openDrawer = () => {
      isDrawerOpen.value = true;
    };

    return {
      addCurrency,
      applyCareplan,
      careplanDescriptionKey,
      careplanInfoHTML,
      closeDrawer,
      image,
      insuranceDescription,
      insurancePrice,
      insuranceSelected,
      insuranceTitle,
      isCartLoading,
      isDrawerOpen,
      isLoading,
      openDrawer,
      priceFormat,
      productName,
      toggleInsuranceSelection,
      translate
    };
  }
});
